import React, { useEffect, useState } from "react";
import Onboarding from "./onboarding/onboarding";
import Header from "../components/header";
import "./home.css";
import HelpIcon from "./assets/helpIcon.png";
import SettingIcon from "./assets/settingIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchFirmDetails } from "../../redux/firmSlice"; // Import fetchFirmDetails thunk

import {
  fetchAttorney,
  fetchToken,
  fetchVideoToken,
} from "../../redux/attorneyDataSlice";

const Home = () => {
  const dispatch = useDispatch();
  const { userId } = useParams(); // Extracts userId from the URL
  const [onboardingComplete, setOnboardingComplete] = useState(false);
  const [loading, setLoading] = useState(true);
  const status = useSelector((state) => state.attorneyData.status);
  const firm_id = useSelector(
    (state) => state.attorneyData.attorneyData?.firm_id
  );

  const attorneyData = useSelector((state) => state.attorneyData.attorneyData);

  // Ensure attorney data is fetched when this page loads (in case prior screens didn't fetch it)
  useEffect(() => {
    if (userId && (!attorneyData || status === "idle" || status === "failed")) {
      dispatch(fetchAttorney(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    const getFirmData = async () => {
      if (firm_id) {
        dispatch(fetchFirmDetails(firm_id));
      } else {
      }
      dispatch(fetchToken(userId)); // Fetch Stream token using user ID
      dispatch(fetchVideoToken(userId)); // Fetch Video token using user ID
    };

    if (status === "succeeded" && attorneyData) {
      setLoading(false);
      getFirmData();
    }
  }, [dispatch, status, attorneyData, firm_id]);

  // Show loading state while data is being fetched
  if (!attorneyData) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading your account...
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="home-outer-container">
        <section className="attorney-home-welcome-section">
          <h1 className="attorney-home-welcome-title">
            Hello{" "}
            {attorneyData
              ? `${attorneyData.first_name} ${attorneyData.last_name}`
              : "Loading..."}
          </h1>
          <div className="welcome-section-right">
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <img
                src={SettingIcon}
                style={{ width: "24px", height: "24px" }}
                alt="settings"
              />
              <p className="welcome-content"> Manage your products </p>
            </div>

            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <img
                src={HelpIcon}
                style={{ width: "24px", height: "24px" }}
                alt="help"
              />
              <p className="welcome-content"> Get support </p>
            </div>
          </div>
        </section>

        <div className="home-container">
          <div className="container-left">
            <Onboarding />
          </div>
          <div className="container-right">
            <div className="attorney-home-performance-section">
              <h2 className="performance-title">Performance Overview</h2>

              <h2 className="bookings-number">0</h2>

              <p className="bookings-subtitle">No bookings yet</p>

              <p className="bookings-footnote">
                Compared to 0 bookings this time last month
              </p>

              <button className="performance-details-button">
                View more performance details
              </button>

              <hr
                style={{
                  justifySelf: "center",
                  marginTop: "10px",
                  marginBottom: "40px",
                  backgroundColor: "#D9D9D9",
                }}
              />

              <h2 className="bookings-number">0</h2>

              <p className="bookings-subtitle">No reviews yet</p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          textAlign: "left",
          padding: "2%",
        }}
      >
        <p className="help-text">Need help?</p>
      </div>
    </div>
  );
};

export default Home;
